<template>
  <div>
    <navbar :links="['dashboard', $route.name]" />
    <v-img
      contain
      src="/static/feedback.png"
      max-width="1024px"
    />
    <h2 class="mt-5 grey--text text--darken-3">
      {{ $t('feedbackPageTitle') }}
    </h2>
    <p class="mt-2 grey--text text--darken-3">
      {{ $t('feedbackHint') }}
    </p>
    <v-layout column>
      <v-textarea
        v-model="feedback"
        box
        :label="$t('feedbackLabel')"
        class="mb-2"
        auto-grow
        :rows="$vuetify.breakpoint.xs ? 5 : 10"
        hide-details
      />
      <v-layout
        row
        style="margin-left: auto"
      >
        <v-slide-x-reverse-transition>
          <btn-abort
            v-if="feedback"
            round
            class="mr-0"
            :title="$t('remove')"
            :label="$t('remove')"
            @click="askRemoveFeedback()"
          />
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition>
          <btn-ok
            round
            :disabled="!feedback"
            :title="$t('submit')"
            :label="$t('submit')"
            icon="send"
            label-with-icon
            class="mr-0"
            @click="submitFeedback(feedback)"
          />
        </v-slide-x-reverse-transition>
      </v-layout>
    </v-layout>
  </div>
</template>

<script>
import BtnAbort from '@/components/ButtonAbort';
import BtnOk from '@/components/ButtonOk';
import Navbar from '@/components/Navbar';

export default {
  components: {
    BtnAbort,
    BtnOk,
    Navbar,
  },
  data() {
    return {
      feedback: '',
    };
  },
  methods: {
    askRemoveFeedback() {
      const confirmed = confirm(this.$t('feedbackRemoveConfirm'));
      if (confirmed) {
        this.feedback = '';
      }
    },
    submitFeedback(message) {
      this.$api.submitUserFeedback(message).then(() => {
        this.$bus.$emit('alert-success', {
          message: 'feedbackSubmitted',
          translate: true,
          timeout: 30000,
        });
        this.reset();
      });
    },
    reset() {
      this.feedback = '';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Feedback.vue